export default ['spletna-stran', 'email', 'telefon'];
